import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ToggleSubscription from "@common/components/account/subscription/ToggleSubscription";
import { formatDate, getToday } from "@common/services/helpers";
import { SUBSCRIPTION_ACTIVE } from "@config/constants";
import { castArray, first, isEmpty } from "lodash";
import React from "react";
import { connect } from "react-redux";
var CurrentSubscription = /*#__PURE__*/ React.memo(function(props) {
    var _userDetails_subscription, _currentPrismicSubscription_title, _currentPrismicSubscription_perks_title;
    var userDetails = props.userDetails, i18n = props.i18n, subscriptionsPrismicAll = props.subscriptionsPrismicAll, _props_hideCurrentPlanBadge = props.hideCurrentPlanBadge, hideCurrentPlanBadge = _props_hideCurrentPlanBadge === void 0 ? false : _props_hideCurrentPlanBadge;
    var _userDetails_subscription_;
    var subscription = (_userDetails_subscription_ = (_userDetails_subscription = userDetails.subscription) === null || _userDetails_subscription === void 0 ? void 0 : _userDetails_subscription[0]) !== null && _userDetails_subscription_ !== void 0 ? _userDetails_subscription_ : null;
    var _subscription_plan_;
    var plan = (_subscription_plan_ = subscription === null || subscription === void 0 ? void 0 : subscription.plan[0]) !== null && _subscription_plan_ !== void 0 ? _subscription_plan_ : null;
    if (!plan || !userDetails || isEmpty(subscriptionsPrismicAll)) return null;
    var subscriptionsPrismic = null;
    var currentPrismicSubscription = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = subscriptionsPrismicAll[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var subscription1 = _step.value;
            var current = castArray(subscription1 === null || subscription1 === void 0 ? void 0 : subscription1.plans_items).find(function(param) {
                var id = param.id;
                return id === (plan === null || plan === void 0 ? void 0 : plan.id);
            });
            if (current) {
                subscriptionsPrismic = subscription1;
                currentPrismicSubscription = current;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var length = (subscription.currentTermEnd - subscription.currentTermStart) * 1000;
    var timePassed = getToday().getTime() - subscription.currentTermStart * 1000;
    var progress = Math.ceil(timePassed * 100 / length);
    var currentActiveSub = first(userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription);
    var currentActivePlan = first(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.plan);
    var isSubscriptionActive = (currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.status) === SUBSCRIPTION_ACTIVE;
    var isFree = (currentActivePlan === null || currentActivePlan === void 0 ? void 0 : currentActivePlan.price) === 0;
    var renderRenewView = function() {
        return /*#__PURE__*/ _jsx(ToggleSubscription, {
            active: false,
            showActiveText: true,
            terminationDate: formatDate(currentActiveSub === null || currentActiveSub === void 0 ? void 0 : currentActiveSub.currentTermEnd),
            onPaymentError: props.onPaymentError,
            disableCancel: isFree
        });
    };
    var renderProgressView = function() {
        var _subscriptionsPrismic_billing_cycle_items_find_title, _subscriptionsPrismic_billing_cycle_items_find, _subscriptionsPrismic_billing_cycle_items;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("span", {
                        className: "active-period-title",
                        children: [
                            i18n.order.activePeriod,
                            ":",
                            /*#__PURE__*/ _jsx("span", {
                                className: "period",
                                children: subscriptionsPrismic === null || subscriptionsPrismic === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items = subscriptionsPrismic.billing_cycle_items) === null || _subscriptionsPrismic_billing_cycle_items === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items_find = _subscriptionsPrismic_billing_cycle_items.find(function(param) {
                                    var period = param.period;
                                    return period === (plan === null || plan === void 0 ? void 0 : plan.cfPeriod);
                                })) === null || _subscriptionsPrismic_billing_cycle_items_find === void 0 ? void 0 : (_subscriptionsPrismic_billing_cycle_items_find_title = _subscriptionsPrismic_billing_cycle_items_find.title) === null || _subscriptionsPrismic_billing_cycle_items_find_title === void 0 ? void 0 : _subscriptionsPrismic_billing_cycle_items_find_title.text
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("span", {
                    className: "date-period",
                    children: [
                        formatDate(subscription.currentTermStart),
                        " -",
                        " ",
                        formatDate(subscription.currentTermEnd)
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "progressbar",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "value",
                        style: {
                            width: "".concat(progress, "%")
                        }
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "order-current-subscription",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    !hideCurrentPlanBadge && /*#__PURE__*/ _jsx("div", {
                        className: "current-plan",
                        dangerouslySetInnerHTML: {
                            __html: i18n.order.currentSubscription
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "title",
                                children: (currentPrismicSubscription === null || currentPrismicSubscription === void 0 ? void 0 : (_currentPrismicSubscription_title = currentPrismicSubscription.title) === null || _currentPrismicSubscription_title === void 0 ? void 0 : _currentPrismicSubscription_title.text) || ""
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "subtitle",
                                children: currentPrismicSubscription === null || currentPrismicSubscription === void 0 ? void 0 : (_currentPrismicSubscription_perks_title = currentPrismicSubscription.perks_title) === null || _currentPrismicSubscription_perks_title === void 0 ? void 0 : _currentPrismicSubscription_perks_title.text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "plan column",
                children: isSubscriptionActive ? renderProgressView() : renderRenewView()
            })
        ]
    });
});
var mapStateToProps = function(param) {
    var userDetails = param.userDetails, i18n = param.i18n;
    return {
        userDetails: userDetails,
        i18n: i18n
    };
};
export default connect(mapStateToProps, {})(CurrentSubscription);
